// extracted by mini-css-extract-plugin
module.exports = {"string":"Page-module--string--3A6Tn","page":"Page-module--page--25KP8"};